import React from "react";

import AdminSectionShell from "../components/AdminSectionShell";
import ViewGerenciarCaracteristicas from "../views/ViewGerenciarCaracteristicas";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const GerenciarCaracteristicas: React.FC = () => {
  const { isLoading, isValid } = usePermissao("ADM");

  if (isLoading) return <p>Verificando permissão...</p>;
  if (!isValid) return null;

  return (
    <AdminSectionShell backTo="/gerenciarConfigSistema">
      <ViewGerenciarCaracteristicas />
    </AdminSectionShell>
  );
};

export default GerenciarCaracteristicas;
